import NewsBox from "./NewsBox";
import React, { useEffect, useState } from "react";
import { ApiController } from "../../../../Utills/ApiController";
import { News } from "../../../../Utills/RestApiModels/NewsModel";

const NewsComponent = () => {
    const [newsData, setNewsData] = useState<News[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        // const controller = new ApiController();
        // controller.GetNewses().then((data: News[] | {error: true, raw: any}) => {
        //     if ((data as any).error) {
        //         setError(true);
        //         setNewsData([]);
        //     } else {
        //         setNewsData(Array.isArray(data) ? data : []);
        //     }
        //     setLoading(false);
        // }).catch(() => {
        //     setError(true);
        //     setLoading(false);
        // });
        setNewsData([])
        setLoading(false)
    }, []);

    return (
        <section id="news" className="py-32 relative">
            <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900/30 to-black"></div>
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-20">
                    <h2 className="text-5xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
                        Aktualności
                    </h2>
                    <p className="mt-4 text-xl text-gray-400">Konferencje, wydarzenia i nowości</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {loading ? (
                        <div className="col-span-3 text-center text-gray-400 py-12">Ładowanie aktualności...</div>
                    ) : error ? (
                        <div className="col-span-3 text-center text-red-500 py-12">Błąd ładowania aktualności</div>
                    ) : newsData.length === 0 ? (
                        <div className="col-span-3 text-center text-gray-400 py-12">Brak aktualności</div>
                    ) : (
                        newsData.map((news, idx) =>
                            NewsBox(
                                news.category,
                                news.title,
                                news.description,
                                news.modificationDate instanceof Date
                                    ? news.modificationDate.toLocaleDateString('pl-PL', { year: 'numeric', month: 'numeric', day: 'numeric' })
                                    : new Date(news.modificationDate).toLocaleDateString('pl-PL', { year: 'numeric', month: 'numeric', day: 'numeric' })
                            )
                        )
                    )}
                </div>
            </div>
        </section>
    );
};

export default NewsComponent;
